// @mui
import React, {useState, useEffect} from 'react'
import { styled } from '@mui/material/styles'
import { Container, Box, Typography } from '@mui/material'
// components

import useMediaQuery from "@mui/material/useMediaQuery";
import Page from '../../components/Page'
import About from './About'
import Publications from './Publications'
import Education from './Education'
import WorkExperience from './WorkExperience'
import InvitedTalks from './InvitedTalks'
import AcademicServices from './AcademicServices'
import News from './News'
// ----------------------------------------------------------------------

const Category = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  marginTop: '80px',
  marginBottom: '15px',
  fontWeight: 700,
  fontSize: '1.6rem',
}))

// ----------------------------------------------------------------------

export default function CV() {
  const [hydrated, setHydrated] = useState(false);
  const isMobile = useMediaQuery('(max-width:900px)');

  useEffect(() => {
    setHydrated(true);
  }, []);

  if (!hydrated) return null;

  return (
    <Page title='Jeonghye Kim' project>
      <Container maxWidth='md' className='cv-content'>
        <About isMobile={isMobile} />

        <Box>
          <Category>News</Category>
          <News isMobile={isMobile}/>
        </Box>

        <Box>
          <Category>Publications</Category>
          <Publications isMobile={isMobile}/>
        </Box>

        <Box>
          <Category>Work Experience</Category>
          <WorkExperience/>
        </Box>

        <Box>
          <Category>Invited Talks</Category>
          <InvitedTalks/>
        </Box>

        <Box>
          <Category>Education</Category>
          <Education/>
        </Box>

        <Box sx={{ mb: 6 }}>
          <Category>Academic Services</Category>
          <AcademicServices/>
        </Box>

      </Container>
    </Page>
  )
}
